var map = {
	"./arrow-r-b.png": 268,
	"./arrow-r.png": 269,
	"./batch.png": 270,
	"./boar_purchase_add.png": 271,
	"./boarmate_add.png": 272,
	"./bot.png": 273,
	"./cooperate.png": 274,
	"./costTools.png": 275,
	"./count_list.png": 276,
	"./create_icon.png": 277,
	"./edit_icon.png": 278,
	"./expend_drug_add.png": 279,
	"./expend_feed_add.png": 280,
	"./expend_semen_add.png": 281,
	"./farm.png": 282,
	"./farm0.png": 283,
	"./farmbg.png": 284,
	"./farml.png": 285,
	"./farrow_add.png": 286,
	"./feed_autostorage_list.png": 287,
	"./form.png": 288,
	"./genealogy_add.png": 289,
	"./hns_add.png": 290,
	"./hogs_dead_add.png": 291,
	"./hogs_purchase_add.png": 292,
	"./hogs_sale_add.png": 293,
	"./hogs_trans_add.png": 294,
	"./line1.png": 295,
	"./loc-date.png": 296,
	"./loc.png": 297,
	"./lose.png": 126,
	"./no_content.png": 298,
	"./nonpregnant_add.png": 299,
	"./procurement_drug_add.png": 300,
	"./procurement_feed_add.png": 301,
	"./procurement_semen_add.png": 302,
	"./produce_semen_add.png": 303,
	"./product.png": 304,
	"./record_add.png": 305,
	"./reportandroid.png": 306,
	"./right.png": 307,
	"./sale_drug_add.png": 308,
	"./sale_feed_add.png": 309,
	"./sale_semen_add.png": 310,
	"./sale_swine_add.png": 311,
	"./sale_swine_list.png": 312,
	"./setting-line.png": 210,
	"./sowmate_add.png": 313,
	"./staff.png": 314,
	"./stock_check_list.png": 315,
	"./swine.png": 316,
	"./swineReport.png": 317,
	"./swine_dead_add.png": 318,
	"./swine_move_add.png": 319,
	"./swine_tranfer_add.png": 320,
	"./switch.png": 321,
	"./wean_add.png": 322
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 620;